import Vue from 'vue';
import {Model} from '@vuex-orm/core';
import moment from 'moment';
import User from "$src/models/userModel";
import File from "$src/models/fileModel";

export default class Post extends Model {

    static entity = 'post';
    static primaryKey = 'id_post';

    static fields() {
        return {
            id_post: this.number(null),
            title: this.attr(null),
            introduction: this.attr(null),
            content: this.attr(null),
            notification: this.attr(null),
            category: this.attr(null),
            published_at: this.attr(null),
            creator: this.belongsTo(User, 'id_creator', 'id_user'),
            file_banner: this.hasOne(File, 'id_file', 'id_file_banner'),
            id_creator: this.attr(null),
            id_file_banner: this.attr(null),
        };
    }

    get categoryString() {
        return Vue.__(`post_category/${this.category}`);
    }

    get statusString() {
        if (!this.published_at) {
            return 'Entwurf';
        } else if (moment().isAfter(this.published_at)) {
            return moment(this.published_at).format('D. MMMM YYYY');
        } else {
            return moment(this.published_at).format('D. MMMM YYYY');
        }
    }

}